
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_94bpo_9",
  "input": "awsui_input_2rhyz_94bpo_13",
  "input-readonly": "awsui_input-readonly_2rhyz_94bpo_62",
  "input-invalid": "awsui_input-invalid_2rhyz_94bpo_105",
  "input-warning": "awsui_input-warning_2rhyz_94bpo_108",
  "input-type-search": "awsui_input-type-search_2rhyz_94bpo_111",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_94bpo_121",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_94bpo_124",
  "input-container": "awsui_input-container_2rhyz_94bpo_128",
  "input-field": "awsui_input-field_2rhyz_94bpo_133",
  "input-field-readonly": "awsui_input-field-readonly_2rhyz_94bpo_157",
  "input-field-disabled": "awsui_input-field-disabled_2rhyz_94bpo_174",
  "input-field-invalid": "awsui_input-field-invalid_2rhyz_94bpo_182",
  "input-field-warning": "awsui_input-field-warning_2rhyz_94bpo_195",
  "input-field-no-border-radius": "awsui_input-field-no-border-radius_2rhyz_94bpo_208",
  "input-field-no-border": "awsui_input-field-no-border_2rhyz_94bpo_208",
  "grouped": "awsui_grouped_2rhyz_94bpo_223",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_94bpo_229",
  "grouped-in-error": "awsui_grouped-in-error_2rhyz_94bpo_236",
  "grouped-in-warning": "awsui_grouped-in-warning_2rhyz_94bpo_241",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_94bpo_256",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_94bpo_280",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_94bpo_307",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_94bpo_334",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_94bpo_358",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_94bpo_385",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_94bpo_385",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_94bpo_415",
  "grouped-validation": "awsui_grouped-validation_2rhyz_94bpo_425",
  "input-prefix": "awsui_input-prefix_2rhyz_94bpo_429",
  "input-suffix": "awsui_input-suffix_2rhyz_94bpo_430",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_94bpo_444",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_94bpo_453",
  "input-icon-start": "awsui_input-icon-start_2rhyz_94bpo_479",
  "input-icon-end": "awsui_input-icon-end_2rhyz_94bpo_486",
  "input-button-right": "awsui_input-button-right_2rhyz_94bpo_492",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_94bpo_496",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_94bpo_499",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_94bpo_503",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_94bpo_506",
  "inline-label": "awsui_inline-label_2rhyz_94bpo_496",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_94bpo_531"
};
  